import React from 'react';
import { useInactivityLogout } from '@/hooks/useInactivityLogout';
import { useTokenMonitor } from '@/hooks/useTokenMonitor';

interface InactivityProviderProps {
  children: React.ReactNode;
}

export const InactivityProvider: React.FC<InactivityProviderProps> = ({ children }) => {
  // Use the inactivity logout hook with 30 minutes timeout
  useInactivityLogout({
    timeout: 30 * 60 * 1000, // 30 minutes
    enabled: true,
    onLogout: () => {
      console.log('User logged out due to inactivity');
    }
  });

  // Monitor token expiration and refresh while user is active
  // Checks every minute, refreshes 5 minutes before expiration
  useTokenMonitor({
    checkInterval: 60 * 1000, // Check every minute
    refreshWindow: 5 * 60 * 1000, // Refresh 5 minutes before expiration
    enabled: true,
  });

  return <>{children}</>;
};
